<template>
  <div
    v-for="ticket in orderedTicketTypes(actualPurchase.selectedTickets)"
    :key="ticket.id"
    class="px-2 md:px-0"
  >
    <ticket-card v-if="!ticketOffice" :ticket="ticket" :open="true" />
    <ticket-card-office v-else :ticket="ticket" />
  </div>
</template>

<script setup>
import { watch } from "vue";
import { usePurchase } from "@/composables/usePurchase";

import TicketCard from "@/components/wegow/purchase/TicketCard";
import TicketCardOffice from "@/components/wegow/purchase/TicketCardOffice";

const { actualPurchase } = usePurchase();

const orderedTicketTypes = tickets =>
  tickets?.sort((a, b) => !a?.available - !b?.available);

defineProps({
  ticketOffice: {
    type: Boolean,
    default: false
  }
});
watch(actualPurchase, async (newValue, oldValue) => {
  actualPurchase.value = newValue;
});
</script>

<script lang="scss" setup></script>
